module.exports = __webpack_public_path__ + "img/infobase_banner.d0df48b4.png";